import styled from 'styled-components/macro';

export const DeleteIconWrapper = styled.div<{ disabled?: boolean; onClick?: () => void }>`
  display: flex;
  align-items: center;

  cursor: pointer;

  &:hover > svg path {
    transition: all 0.2s ease;

    stroke: ${({ theme, disabled }) => (disabled ? theme.colors.black_5 : theme.colors.black_80)};
  }
`;
